/**
 * Shows the `_mega-menu` block(s) whose `menu-handle` matches the top-level
 * link's `title-handle`, and hides the rest. Every `_mega-menu` child block
 * currently renders under every top-level link (Liquid can't reliably read a
 * nested block's settings from its static parent without rendering it), so
 * this does the "which link does it belong under" matching client-side
 * instead, where the attributes are always correctly resolved.
 */
(function initMegaMenuSync() {
  function applySync() {
    document.querySelectorAll('header-menu li.menu-list__list-item').forEach((item) => {
      const titleHandle = item.getAttribute('title-handle');
      if (!titleHandle) return;

      item.querySelectorAll('.mega__menu').forEach((megaMenu) => {
        const menuHandle = megaMenu.getAttribute('menu-handle');
        if (!menuHandle) return;

        megaMenu.style.display = titleHandle === menuHandle ? 'flex' : 'none';
      });
    });
  }

  applySync();

  new MutationObserver(applySync).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
